import { Observable } from 'rxjs';
import httpService from './httpService';
import {
  ConversationMessage,
  ConversationSession,
  ConversationQuery,
} from '../data/models/ai-conversation.model';

class AiService {
  private readonly apiBase;

  constructor() {
    const { __environment__ } = window as any;
    this.apiBase = __environment__.REACT_APP_AI_SERVICES_API_URL.trim();
  }

  public getConversations(): Observable<ConversationSession[]> {
    const url = `${this.apiBase}/conversations`;
    return httpService.getJSON(url);
  }

  public getConversationMessages(
    conversationId: string,
  ): Observable<ConversationSession> {
    const url = `${this.apiBase}/conversations/${conversationId}`;
    return httpService.getJSON(url);
  }

  public createConversationSession(
    conversation: ConversationQuery,
  ): Observable<ConversationSession> {
    const url = `${this.apiBase}/conversations`;
    return httpService.postJSON(url, conversation);
  }

  public sendMessage(
    conversationId: string,
    message: ConversationQuery,
  ): Observable<ConversationMessage> {
    const url = `${this.apiBase}/conversations/${conversationId}/messages`;
    return httpService.postJSON(url, message);
  }
}

const aiService = new AiService();

export { aiService };
